import React from 'react';
import { useFormContext, useController } from 'react-hook-form';
import { OrgOrgUnitSelectors } from '@shared/components/inputs/OrgOrgUnitSelectors';

/**
 * @typedef {object} FormOrgOrgUnitSelectorOwnProps
 * @property {{ name: string }} orgSelectorProps
 * @property {{ name: string }} orgUnitSelectorProps
 */

/**
 * @typedef {FormOrgOrgUnitSelectorOwnProps &
 *   React.ComponentPropsWithoutRef<typeof OrgOrgUnitSelectors>} FormOrgOrgUnitSelectorProps
 */

/**
 * @param {FormOrgOrgUnitSelectorProps} props
 */
export const FormOrgOrgUnitSelector = props => {
  const { organizations, selectorMode, orgSelectorProps, orgUnitSelectorProps, ...otherProps } =
    props;

  const { control } = useFormContext();

  const { field: orgField } = useController({
    name: orgSelectorProps.name,
    control
  });
  const {
    field: orgUnitField,
    fieldState: { error: orgUnitFieldError }
  } = useController({
    name: orgUnitSelectorProps.name,
    control
  });

  return (
    <div className='page-section'>
      <OrgOrgUnitSelectors
        {...otherProps}
        organizations={organizations}
        selectorMode={selectorMode}
        orgSelectorProps={{
          ...orgField,
          ...orgSelectorProps
        }}
        orgUnitSelectorProps={{
          ...orgUnitField,
          ...orgUnitSelectorProps,
          hasError: Boolean(orgUnitFieldError)
        }}
      />
    </div>
  );
};
